import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Preview = styled.img`
  position: relative;
  padding: 0;
  margin: 0;
  height: 360px;
  width: 640px;
`;

class GraphicPreview extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      src: props.src
    };

    this.reload = this.reload.bind(this);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.src !== this.props.src) {
      this.setState({ src: nextProps.src });
    }
  }
  reload() {
    this.setState({ src: `${this.props.src}?t=${new Date().getTime()}` });
  }
  render() {
    if (this.state.src) {
      return (
        <Preview
          style={{ top: `${this.props.index * -360}px` }}
          src={this.state.src}
          onError={() => { setTimeout(this.reload, 1000); }}
        />
      );
    }

    return null;
  }
}

GraphicPreview.defaultProps = {
  index: 0,
  src: ''
};

GraphicPreview.propTypes = {
  index: PropTypes.number.isRequired,
  src: PropTypes.string
};

export default GraphicPreview;



// WEBPACK FOOTER //
// ./app/components/Clipper/GraphicPreview.js